import React from 'react';
import { ArrowRight } from '@yme/assets/icons';
import { FilterMenuButtonStyled, FilterMenuItemStyled } from './styled';
export function FilterMenuItem({ item, onClickHandler, label }) {
    return (React.createElement(FilterMenuItemStyled, null,
        React.createElement(FilterMenuButtonStyled, { onClick: () => {
                onClickHandler(item.label);
            }, iconType: ArrowRight, isPaddingsReset: true }, label),
        item.component));
}
